/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPublicDataBase, FxIdApplicationPublicDataBuilderPublicDataBaseFromJSONTyped, FxIdApplicationPublicDataBuilderPublicDataBaseToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBase';
export function FxIdWebFeaturesGamesChooseGameResponsePublicGameDataFromJSON(json) {
    return FxIdWebFeaturesGamesChooseGameResponsePublicGameDataFromJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesChooseGameResponsePublicGameDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBase(json)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesGamesChooseGameResponsePublicGameDataToJSON(json) {
    return FxIdWebFeaturesGamesChooseGameResponsePublicGameDataToJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesChooseGameResponsePublicGameDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBase(value)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesGamesChooseGameResponsePublicGameData.js.map